import BaseObject from './BaseObject';
import Occasion from '@support/Occasion';

type InteractionType =
  | 'First Event'
  | 'Last Event'
  | 'Upcoming Event'
  | 'First Email'
  | 'Last Email'
  | 'First Message'
  | 'Last Message';

type InteractionGroup = 'email' | 'event' | 'message';

interface ClientURLs {
  superhuman_url?: string;
}

export class Interaction {
  date: Occasion;
  title: string;
  type: InteractionType;
  group: InteractionGroup;
  private $url: string;
  duration?: string;
  future?: boolean;

  client_urls: ClientURLs = {};

  constructor(props: any) {
    this.date = new Occasion(props.date || props.start_datetime);
    this.title = props.title || props.subject;
    this.type = props.type;
    this.group = props.group;
    this.$url = props.url;

    if (props.superhuman_url) {
      this.client_urls.superhuman_url = props.superhuman_url;
    }

    if (props.future) {
      const end = new Occasion(props.end_datetime);
      this.duration = `${this.date.format(Occasion.timeFormat)} - ${end.format(
        Occasion.timeFormat,
      )}`;
      this.future = true;
    }

    if (!this.title && this.group == 'email') {
      this.title = '(no subject)';
    }

    if (!this.title && this.group == 'event') {
      this.title = '(no event title)';
    }
  }

  private get clientUrl(): string | null {
    let client = null;

    if (typeof window !== 'undefined') {
      client = window.localStorage.getItem(`${this.group}_client`);
    }

    if (client) {
      return this.client_urls[`${client}_url`] || null;
    }

    return null;
  }

  get url() {
    return this.clientUrl || this.$url;
  }
}

export class Moments extends BaseObject {
  summary: Array<string>;
  interactions: Array<Interaction>;

  constructor(props: any = {}) {
    super(props);

    const interactions = [];
    const { emails, events, messages, summary } = props;

    this.summary = summary || [];

    if (events && events.first) {
      interactions.push(new Interaction({ ...events.first, type: 'First Event', group: 'event' }));
    }

    if (events && events.last) {
      interactions.push(new Interaction({ ...events.last, type: 'Last Event', group: 'event' }));
    }

    if (events && events.upcoming) {
      interactions.push(
        new Interaction({
          ...events.upcoming,
          type: 'Upcoming Event',
          future: true,
          group: 'event',
        }),
      );
    }

    if (emails && emails.first) {
      interactions.push(new Interaction({ ...emails.first, type: 'First Email', group: 'email' }));
    }

    if (emails && emails.last) {
      interactions.push(new Interaction({ ...emails.last, type: 'Last Email', group: 'email' }));
    }

    if (messages && messages.first) {
      interactions.push(
        new Interaction({ ...messages.first, type: 'First Message', group: 'message' }),
      );
    }

    if (messages && messages.last) {
      interactions.push(
        new Interaction({ ...messages.last, type: 'Last Message', group: 'message' }),
      );
    }

    interactions.sort((a, b) => b.date.date - a.date.date);

    if (interactions.length > 0) {
      this.interactions = interactions;
    } else {
      this.interactions = props.interactions || [];
    }
  }
}
